import MultiplicationKeyItem from "../../../items/games/multiplicationGameScreen/MultiplicationKeyItem";
import MultiplicationGameValidateButton from "../../../buttons/games/MultiplicationGameValidateButton";

export default function MultiplicationGameKeyboard({userAnswer, onKeyPressed}) {
    // Used in MultiplicationGameContent to display
    // specific keyboard for this game

    // CONSTANTS
    const keys = [
        '1', '2', '3',
        '4', '5', '6',
        '7', '8', '9',
        '-/+', '0', 'Erase'
    ];

    // BUILD
    return (
        <div className={"w-full flex flex-col mt-[24px]"}>
            <div className="w-full grid grid-cols-3 gap-[12px]">
                {keys.map((item, index) => (
                    <MultiplicationKeyItem key={index}
                                           item={item}
                                           userAnswer={userAnswer}
                                           onKeyPressed={onKeyPressed} />
                ))}
            </div>
            <MultiplicationGameValidateButton userAnswer={userAnswer}
                                              onKeyPressed={onKeyPressed} />
        </div>
    );
}